import { useTranslation } from 'react-i18next';
import type { NavItem, ViewKey } from '../nav/navModel';
import { Icon } from './Icon';

interface Props {
  items: NavItem[];
  active: ViewKey;
  onSelect: (view: ViewKey) => void;
}

/** Menú lateral con la estructura del prototipo: <nav class="nav"><button data-view>… */
export function SideNav({ items, active, onSelect }: Props) {
  const { t } = useTranslation();
  return (
    <nav className="nav" id="nav">
      {items.map((item) => (
        <button
          key={item.view}
          type="button"
          data-view={item.view}
          className={item.view === active ? 'active' : ''}
          onClick={() => onSelect(item.view)}
        >
          {/* El símbolo del prototipo se conserva como texto oculto (paridad); a la vista va el ícono de línea. */}
          <span className="ico">
            <Icon name={item.view} size={18} />
            <span className="sr-only">{item.icon}</span>
          </span>
          <span>{t(`nav.${item.view}`)}</span>
        </button>
      ))}
    </nav>
  );
}
